import React from 'react';
import { header } from 'constants/table';
import {ThongKeBaoCao} from 'api';
import DataTable from 'components/data-table';
import {Text} from 'components/tt-forms/common';
import {ContainerFileDinhKem} from 'components/upload';
import {browserHistory} from 'react-router';
import {MasterLayout} from 'layout';
import { Button } from '@blueprintjs/core';
import {ConfirmDialog} from 'modules/dialog';
import { msg } from "constants/message";
import {ShowIf} from 'components/utils';
import { API_URL } from 'constants/config';
import { Link } from 'react-router';
import TableKetQuaPhongChongThamNhung from 'modules/bao-cao-dinh-ky/TableKetQuaPhongChongThamNhung.jsx';
import {
  RowItemCongTacQuanLyNhaNuoc,
  ListItemThongKeTiepCongDan,
  ListItemThongKeGQDKN,
  ListItemThongKeGQDTC,
  ListItemThongKeXuLyDon,
  ListItemThongKeThanhTraHanhChinh,
  ListItemThongKeThanhTraXayDungCoBan,
  ListItemThongKeThanhTraDatDai,
  ListItemThongKeThanhTraChuyenNganh,
  ListItemThongKeThanhTraLai,
  ListItemThongKeThanhTraXayTaiChinhNganSach,
  ListItemThongKeThanhTraThamNhung,
  RowItemXayDungLucLuongThanhTra,
  RowItemCongTacQuanLyNhaNuocKNTC,
  RowItemTongHopKeKhai
} from 'modules/bao-cao-dinh-ky/datatable';
import { Toastr } from 'modules/toastr';
import moment from 'moment';

class LapBaoCaoTongHop extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataDelete: [],
      loaiBaoCao: [],
      tableLoading: false,
      update: false,
      showFile: false,
      listTaiLieuBaoCao: [],
      listTaiLieuVanThu: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataFileDinhKemDelete: [],
      dataTaiLieuVanThuDelete: [],
      thongTinBaoCao: {},
      headerTable: [],
      trangThaiBaoCao: '',
      baoCaoTongHopChiTietId: '',
      hasChange: false,
      backConfirm: false,
      checkComponent: false,
      numberColumnHeader: 50,
      convertData: false,
      openDialog: false,
      dataSum: {donVi: {id: 'DATA_SUM'}},
      dataOption: [],
      popupChotBaoCao: false,
    }
  }

  componentDidMount() {
    this.getDataLapBaoCaoTongHopChiTiet(this.props.params.id);
    this.getLapBaoCaoTongHopChiTiet(this.props.params.id);
  }

  getDataLapBaoCaoTongHopChiTietKhac(id) {
    ThongKeBaoCao.actions.getDataLapBaoCaoTongHopChiTietKhac.request({idBaoCaoTongHopChiTiet: id}).then(res => {
      if (res.data && res.data._embedded) {
        let data = [...res.data._embedded.baoCaoTongHopChiTietKhacs];
        let newData = [...this.state.data];
        data.map(item => {
          let itemDetail = item.soLieuBaoCaoInfo || {};
          itemDetail.donVi = {
            id: item.baoCaoDonViInfo ? item.baoCaoDonViInfo.donViId : null,
            ten: item.soLieuBaoCaoInfo ? item.soLieuBaoCaoInfo.tenDonVi : ''
          }
          itemDetail.id = item.baoCaoTongHopChiTietKhacId;
          newData.push(itemDetail);
        })
        this.setState({
          data : newData
        })
        this.checkSum(newData);
      } else {
        this.checkSum(this.state.data)
      }
    })
  }

  getDataLapBaoCaoTongHopChiTiet(id) {
    ThongKeBaoCao.actions.getDataLapBaoCaoTongHopChiTiet.request({id: id}).then(res => {
      if (res.data && res.data._embedded) {
        let data = [...res.data._embedded.baoCaoDonViChiTiets];
        let newData = [];
        data.map(item => {
          let itemDetail = item.soLieuBaoCaoInfo || {};
          itemDetail.donVi = {
            id: item.baoCaoDonViInfo ? item.baoCaoDonViInfo.donViId : null,
            ten: item.soLieuBaoCaoInfo ? item.soLieuBaoCaoInfo.tenDonVi : '',
            trangThaiBaoCao: item.baoCaoDonViInfo.trangThaiBaoCaoInfo.giaTri ? item.baoCaoDonViInfo.trangThaiBaoCaoInfo.giaTri : '',
          }
          itemDetail.id = item.baoCaoDonViChiTietId;
          itemDetail.laySoLieu = item.laySoLieu;
          itemDetail.trangThaiBaoCao = item.trangThaiBaoCao;
          newData.push(itemDetail);
        })
        this.setState({
          data : newData,
        }, () => {
          this.getDataLapBaoCaoTongHopChiTietKhac(id)
        })
      }
    })
  }

  importData(index, id) {
    ThongKeBaoCao.actions.laySoLieuTongHop.request({id: id}).then(res => {
      if (res.data) {
        let item = res.data;
        let itemDetail = item.soLieuBaoCaoInfo || {};
        itemDetail.donVi = {
          id: item.baoCaoDonViInfo ? item.baoCaoDonViInfo.donViId : null,
          ten: item.soLieuBaoCaoInfo ? item.soLieuBaoCaoInfo.tenDonVi : ''
        }
        itemDetail.id = item.baoCaoDonViChiTietId;
        itemDetail.laySoLieu = item.laySoLieu;
        this.state.data[index] = itemDetail;

        this.setState({
          ...this.state
        }, () => {
          this.checkSum(this.state.data)
        })
        let message = 'Dữ liệu của ' + itemDetail.tenDonVi + ' đã được cập nhật';
        Toastr(message, 'success');
      }
    })
  }

  CheckNullObj(obj) {
    let newObj = {...obj};
    delete newObj['donVi'];
    delete newObj['addNew'];
    delete newObj['id'];
    for (var member in newObj) {
      if (newObj[member] != null && newObj[member] != 0 && newObj[member] != '') {
        return false;
      }
    }
    return true;
  }

  checkSum(arr) {
    if(arr.length > 0) {
      let newObj = arr[0];
      let dataSum = {
        donVi: {
          id: 'DATA_SUM',
          ten: 'dataSum'
        }
      }
      for (var member in newObj) {
        if (member != 'id' && member != 'donVi' && member != 'tenDonVi' && member != 'ghiChu') {
          let sum = this.checkSumElement(arr, member);
          dataSum[member] = sum;
        }
      }
      this.setState({
        dataSum: dataSum
      })
    }
  }

  checkSumElement(arr, field) {
    let sum = 0;
    if(arr.length > 0) {
      arr.map(item => {
        sum = sum + Number(item[field])
      })
    }
    return sum;
  }

  getLapBaoCaoTongHopChiTiet(id) {
    ThongKeBaoCao.actions.getLapBaoCaoTongHopChiTiet.request({id:id}).then(res => {
      if(res.data) {
        let data = res.data;
        this.state.baoCaoTongHopChiTietId = data.baoCaoTongHopChiTietId ? data.baoCaoTongHopChiTietId : '';
        this.state.trangThaiBaoCao = data.trangThaiBaoCao ? data.trangThaiBaoCao : '';
        this.state.listTaiLieuBaoCao = data.listTaiLieuBaoCao ? data.listTaiLieuBaoCao : [];
        this.state.thongTinBaoCao = data.thongTinBaoCaoInfo ? data.thongTinBaoCaoInfo : {};
        this.state.tenBaoCao = data.loaiBaoCaoInfo ? data.loaiBaoCaoInfo.ten : '';
        this.state.nameRowItem = data.loaiBaoCao ? data.loaiBaoCao : '';
      }
      this.setState({
        ...this.state
      }, () => {
        this.checkFileRequire()
      })
    })
  }

  checkFileRequire() {
    let data = [...this.state.listTaiLieuBaoCao];

    let dataFilter = data.filter(state => {
      return state.typeRequired == 'BCDK_TLVT'
    })

    if(dataFilter.length > 0) {
      let dataOld = [...this.state.listTaiLieuBaoCao];
      let newData = [];
      dataOld.map(item => {
        let newItem = {
          ten: item.ten,
          soQuyetDinh: item.soVanBan,
          required: item.required,
          typeRequired: item.typeRequired,
          tenFile: item.tenFile,
          taiLieuVanThuId: item.taiLieuBaoCaoId,
          ngayQuyetDinh: item.ngayRaVanBan,
          duongDan: item.urlFile
        }
        newData.push(newItem);
      })
      this.state.listTaiLieuVanThu = newData;
      this.state.showFile = true;
    } else {
      let dataOld = [...this.state.listTaiLieuBaoCao];
      let newData = [];
      dataOld.map(item => {
        let newItem = {
          ten: item.ten,
          soQuyetDinh: item.soVanBan,
          required: item.required,
          typeRequired: item.typeRequired,
          tenFile: item.tenFile,
          taiLieuVanThuId: item.taiLieuBaoCaoId,
          ngayQuyetDinh: item.ngayRaVanBan,
          duongDan: item.urlFile
        }
        newData.push(newItem);
      })

      let itemRequired = {
        ten: 'Văn bản báo cáo',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'BCDK_TLVT',
        newFile: true
      }
      this.state.listTaiLieuVanThu = [
        ...newData,
        itemRequired
      ]
      this.state.showFile = true;
    }
    this.setState({
      ...this.state
    })
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data,
      hasChange: true
    });
  }

  onFileRemove(id, data) {
    this.state.dataFileDinhKemDelete = [
      ...this.state.dataFileDinhKemDelete,
      id
    ];
    this.state.dataFileDinhKem = data;
    this.state.hasChange = true;
    this.forceUpdate();
  }

  handleBack(allowBack) {
    if (allowBack == true) {
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.setState({backConfirm: true});
      } else {
        browserHistory.goBack();
      }
    }
  }

  closeConfirmBack() {
    this.setState({backConfirm:false});
  }

  guiBaoCao(type) {
    if(type == 'export' || this.validateSubmitForm()) {
      this.pushTaiLieuDinhKem();
      let paramsPost = this.getParams('POST');
      let paramsPatch = this.getParams('PATCH');
      let paramsPatchKhac = this.getParams('PATCH_KHAC');
      this.checkDelete(paramsPost, paramsPatch, paramsPatchKhac, type, () => {
        this.checkCreate(paramsPost, paramsPatch, paramsPatchKhac, type, () => {
          this.checkOtherEdit(paramsPatch, paramsPatchKhac, type, () => {
            this.checkEdit(paramsPatch, type, () => {
              if (type == 'export') {
                let URL = API_URL + "/baoCaoTongHopChiTiets/xuatExcel?"
                + "idBaoCaoTongHopChiTiet=" + Number(this.props.params.id);
                window.open(URL, "_self");
              }
            });
          });
        });
      });

      if(paramsPost.length == 0 && paramsPatchKhac.length == 0 && this.state.dataDelete.length == 0 && paramsPatch.length == 0) {
        if(type != 'export') {
          this.handleBack(true);
        }
        Toastr(msg.dkLuuHoSo, 'success');
      }
    }
  }

  checkEdit(paramsPatch, type, callBack) {
    if(paramsPatch.length > 0) {
      let params = {
        baoCaoDonViChiTiets: [
          ...paramsPatch
        ]
      }
      ThongKeBaoCao.actions.patchBaoCaoTongHop.request('', params).then(res => {
        if(type != 'export') {
          this.handleBack(true);
        }
        callBack()
        Toastr(msg.dkLuuHoSo, 'success');
      }).catch(err => {
        callBack()
      })
    } else {
      callBack()
    }
  }

  checkOtherEdit(paramsPatch, paramsPatchKhac, type, callBack) {
    if(paramsPatchKhac.length > 0) {
      let params = {
        baoCaoTongHopChiTietKhacs: [
          ...paramsPatchKhac
        ]
      }
      ThongKeBaoCao.actions.patchBaoCaoTongHopKhac.request('', params).then(res => {
        if ( paramsPatch.length == 0) {
          if(type != 'export') {
            this.handleBack(true);
          }
          callBack()
          Toastr(msg.dkLuuHoSo, 'success');
        } else {
          callBack()
        }
      }).catch(err => {
        callBack()
      })
    } else {
      callBack()
    }
  }

  checkCreate(paramsPost, paramsPatch, paramsPatchKhac, type, callBack) {
    if(paramsPost.length > 0) {
      let params = {
        baoCaoTongHopChiTietKhacs: [
          ...paramsPost
        ]
      }
      ThongKeBaoCao.actions.postBaoCaoTongHop.request('', params).then(res => {
        if(paramsPatchKhac.length == 0 && paramsPatch.length == 0) {
          if(type != 'export') {
            this.handleBack(true);
          }
          callBack()
          Toastr(msg.dkLuuHoSo, 'success');
        } else {
          callBack()
        }
        this.getDataLapBaoCaoTongHopChiTiet(this.props.params.id);
      }).catch(err => {
        callBack()
      })
    } else {
      callBack()
    }
  }

  checkDelete(paramsPost, paramsPatch, paramsPatchKhac, type, callBack) {
    if(this.state.dataDelete.length > 0) {
      let params = {
        baoCaoTongHopChiTietKhacs: [
          ...this.state.dataDelete
        ]
      };
      ThongKeBaoCao.actions.deleteBaoCaoTongHop.request('', params).then(res => {
        if(paramsPost.length == 0 && paramsPatch.length == 0 && paramsPatchKhac.length == 0) {
          if(type != 'export') {
            this.handleBack(true);
          }
          callBack()
          Toastr(msg.dkLuuHoSo, 'success');
        } else {
          callBack()
        }
      }).catch(err => {
        callBack()
      })
    } else {
      callBack()
    }
  }

  pushTaiLieuDinhKem() {
    let dataFileDinhKem = [...this.state.dataFileDinhKem];

    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            baoCaoTongHopChiTiet: {
              id: Number(this.props.params.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soVanBan: item.soQuyetDinh,
            ngayRaVanBan: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            urlFile: item.duongDan,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            baoCaoTongHopChiTiet: {
              id: Number(this.props.params.id)
            },
            ten: item.ten,
            soVanBan: item.soQuyetDinh,
            ngayRaVanBan: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            urlFile: item.duongDan,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });
    }

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }

    if(this.state.taiLieuVanThu.length > 0) {
      let params = {
        taiLieuBaoCaos: this.state.taiLieuVanThu
      }
      this.postTaiLieuVanThu(params);
    }

    if(this.state.taiLieuVanThuUpdate.length > 0) {
      let params = {
        taiLieuBaoCaos: this.state.taiLieuVanThuUpdate
      }
      this.updateTaiLieuVanThu(params);
    }

    if(this.state.taiLieuVanThuDelete.length > 0) {

      let params = {
        taiLieuBaoCaos: this.state.taiLieuVanThuDelete
      }
      this.deleteTaiLieuVanThu(params);
    }
    this.setState({dataFileDinhKem: []});
  }

  updateTaiLieuVanThu(params) {
    ThongKeBaoCao.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    ThongKeBaoCao.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    ThongKeBaoCao.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  getParams(type) {
    let data = [...this.state.data];
    if(type == 'POST') {
      let dataPost = [];
      let dataPostFilter = data.filter(state => {
        return state.addNew == true
      })
      dataPostFilter.map(state => {
        if(this.CheckNullObj(state)) {
          // do nothing
        } else {
          let item = {
            baoCaoTongHopChiTiet: {
              id: Number(this.props.params.id)
            },
            soLieuBaoCao: {...state}
          }
          delete item.soLieuBaoCao['donVi'];
          delete item.soLieuBaoCao['addNew'];
          dataPost.push(item)
        }
      })

      return dataPost;
    } else if (type =='PATCH') {
      let dataPatch = [];
      let dataPatchFilter = data.filter(state => {
        return state.addNew != true && state.donVi.id
      })
      dataPatchFilter.map(state => {
        let item = {
          soLieuBaoCao: {...state}
        }
        if(state.id) {
          item.baoCaoDonViChiTietId = state.id
        }
        delete item.soLieuBaoCao['donVi'];
        delete item.soLieuBaoCao['addNew'];
        delete item.soLieuBaoCao['id'];
        delete item.soLieuBaoCao['laySoLieu'];
        delete item.soLieuBaoCao['trangThaiBaoCao'];
        dataPatch.push(item)
      })
      return dataPatch;
    } else {
      let dataPatch = [];
      let dataPatchFilter = data.filter(state => {
        return state.addNew != true && !state.donVi.id
      })
      dataPatchFilter.map(state => {
        if(this.CheckNullObj(state)) {
          let itemDelete = {
            id: state.id
          }
          this.state.dataDelete.push(itemDelete);
        } else {
          let item = {
            baoCaoTongHopChiTiet: {
              id: Number(this.props.params.id)
            },
            soLieuBaoCao: {...state}
          }
          if(state.id) {
            item.baoCaoTongHopChiTietKhacId = state.id
          }
          delete item.soLieuBaoCao['donVi'];
          delete item.soLieuBaoCao['addNew'];
          delete item.soLieuBaoCao['id'];
          delete item.soLieuBaoCao['laySoLieu'];
          delete item.soLieuBaoCao['trangThaiBaoCao'];
          dataPatch.push(item)
        }
      })
      return dataPatch;
    }
  }

  onChange(name,e) {}

  addNewItem() {
    ThongKeBaoCao.actions.getItemHeThongLapBaoCaoTongHopChiTiet.request({idBaoCaoTongHopChiTiet: this.props.params.id}).then(res => {
      if(res.data) {
        let item = res.data;
        let newItem = item.soLieuBaoCaoInfo;
        newItem.donVi = {
          id: null,
          ten: ''
        }
        newItem.addNew = true;
        this.setState({
          data: [
          ...this.state.data,
          newItem
          ]
        })
      }
    })
    this.setState({
      hasChange: true
    })
  }

  onRemoveItem(id) {
    let data= [...this.state.data];
    let index = data.findIndex(x => x.donVi.id == id);
    if(index != -1) {
      let itemDelete = {
        id: data[index].id
      }
      this.state.dataDelete.push(itemDelete);
      data.splice(index, 1)
      this.state.data = data;
      this.setState({
        ...this.state
      }, () => {
        this.checkSum(this.state.data)
      })
    }
    this.setState({
      hasChange: true
    })
  }

  onChangeHeader(index, e) {
    this.state.data[index].tenDonVi = e.target.value;
    this.state.data[index].donVi = {
      id: null,
      ten: e.target.value
    }
    this.state.hasChange = true;
    this.setState({
      ...this.state
    })
  }

  onItemChange(index, data) {
    this.state.data[index] = {
      ...this.state.data[index],
      ...data};
    this.state.hasChange = true;
    this.setState({
      ...this.state
    }, () => {
      this.checkSum(this.state.data)
    })
  }

  reciveData(data) {
    this.state.data = data;
    this.state.hasChange = true;
    this.setState({
      ...this.state
    }, () => {
      this.checkSum(this.state.data)
    })
  }
  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }
  exportExcel(type) {
    if (type == 'export') {
      this.setState({
        openDialog: false,
        hasChange: false
      });
      this.guiBaoCao('export');
      this.setState({popupChotBaoCao: true});
    } else if(this.state.hasChange == true) {
      this.setState({
        openDialog: true
      })
    } else {
      this.guiBaoCao('export');
      this.setState({popupChotBaoCao: true});
    }
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    })
  }

  chotBaoCao(inputId) {
    ThongKeBaoCao.actions.patchChotSoLieuTongHop.request({id: inputId}).then(res => {
      this.closeDialog('popupChotBaoCao');
    });
  }

  render() {
    let ngayChot = moment().format('DD/MM/YYYY');
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
          <div className="back-foward mb0">
            <Link onClick={browserHistory.goBack}>Về trang trước</Link>
          </div>
          <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
            title={msg.confirmBack} />
          <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this, 'openDialog')} onSuccess={this.exportExcel.bind(this, 'export')}
            title={msg.confirmExportExcel} />
          <ConfirmDialog open={this.state.popupChotBaoCao} onClose={this.closeDialog.bind(this, 'popupChotBaoCao')} onSuccess={this.chotBaoCao.bind(this, this.props.params.id)}
          title={`Số liệu báo cáo sẽ được chốt ngày ${ngayChot}`} />
          <div className="top-content">
            <div className="left-content">
              <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_QUY'}>
                <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.tenBaoCao ? this.state.tenBaoCao : ''} quý ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.quyBaoCao : ''} năm ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : ''}`}</p>
              </ShowIf>
              <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_THANG'}>
                <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.tenBaoCao ? this.state.tenBaoCao : ''} tháng ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.thangBaoCao + 1 : ''} năm ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : ''}`}</p>
              </ShowIf>
              <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao != 'THEO_THANG' && this.state.thongTinBaoCao.kyBaoCao != 'THEO_QUY'}>
                <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.tenBaoCao ? this.state.tenBaoCao : ''} ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.kyBaoCaoText : ''} năm ${this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : ''}`}</p>
              </ShowIf>
            </div>
          </div>
          <div className="bottom-content thongke-content">
            <div className='row pl10 pr10'>
              <h2 className='title-14 col-100 pt20 pl20 pr20'>1. Thông tin báo cáo</h2>
            </div>
            <div className='row pl25 pt10 pr25'>
              <Text className='col-100 mb10' label='Biểu mẫu:' value={this.state.tenBaoCao ? this.state.tenBaoCao : ''} />
              <Text className='col-25 mb10' label='Kỳ báo cáo:' value={this.state.thongTinBaoCao ? this.state.thongTinBaoCao.kyBaoCaoText : ''} />
              <Text className='col-25 mb10' label='Năm báo cáo:' value={this.state.thongTinBaoCao ? this.state.thongTinBaoCao.namBaoCao : ''} />
              <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_QUY'}>
                <Text className='col-25 mb10' label='Quý:' value={this.state.thongTinBaoCao ? this.state.thongTinBaoCao.quyBaoCao : ''} />
              </ShowIf>
              <ShowIf condition={this.state.thongTinBaoCao && this.state.thongTinBaoCao.kyBaoCao == 'THEO_THANG'}>
                <Text className='col-25 mb10' label='Tháng:' value={this.state.thongTinBaoCao ? this.state.thongTinBaoCao.thangBaoCao + 1 : ''} />
              </ShowIf>
            </div>
            <div className='row pl15 pr15'>
              <div className='big-border'/>
            </div>
            <div className="wrap-table clear-left">
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_HANH_CHINH'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoThanhTraHanhChinh}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={34}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeThanhTraHanhChinh importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAU_TU_XAY_DUNG_CO_BAN'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoThanhTraXayDungCoBan}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={34}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeThanhTraXayDungCoBan importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_TAI_CHINH_NGAN_SACH'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoThanhTraTaiChinhNganSach}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={28}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeThanhTraXayTaiChinhNganSach importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAT_DAI'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoThanhTraDatDai}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={44}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeThanhTraDatDai importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_LAI'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoThanhTraLai}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={32}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeThanhTraLai importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoThanhTraChuyenNganh}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={30}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeThanhTraChuyenNganh importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_PHAT_HIEN_XU_LY_THAM_NHUNG_QUA_THANH_TRA'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoThanhTraThamNhung}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={28}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeThanhTraThamNhung importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_THANH_TRA'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.nhaNuocVeThanhTra}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={24}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <RowItemCongTacQuanLyNhaNuoc importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'CONG_TAC_XAY_DUNG_LUC_LUONG_THANH_TRA'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.xayDungLucLuongThanhTra}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={27}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <RowItemXayDungLucLuongThanhTra importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_TIEP_CONG_DAN'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoTiepCongDan}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={38}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeTiepCongDan importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_XU_LY_DON_KHIEU_NAI_TO_CAO'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoXuLyDon}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={34}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeXuLyDon importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_GIAI_QUYET_DON_KHIEU_NAI'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoGiaiQuyetDonKN}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={41}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeGQDKN importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_GIAI_QUYET_DON_TO_CAO'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoGiaiQuyetDonTC}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={36}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <ListItemThongKeGQDTC importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_KHIEU_NAI_TO_CAO'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.quanLyNhaNuocVeKhieuNaiToCao}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={20}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <RowItemCongTacQuanLyNhaNuocKNTC importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'KET_QUA_CHU_YEU_VE_CONG_TAC_PHONG_CHONG_THAM_NHUNG'} >
                <TableKetQuaPhongChongThamNhung
                  addNew={true}
                  touchMove={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.thongKeBaoCaoGiaiQuyetDonTC}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={this.state.numberColumnHeader}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  pushData={this.reciveData.bind(this)}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                />
              </ShowIf>
              <ShowIf condition={this.state.nameRowItem == 'SO_LIEU_KE_KHAI_XAC_MINH_TAI_SAN'} >
                <DataTable
                  touchMove={true}
                  lapBaoCaoTongHop={true}
                  addNew={true}
                  addNewItem={this.addNewItem.bind(this)}
                  header={header.tongHopSoLieu}
                  dataList={this.state.data}
                  exporttext="Xuất báo cáo"
                  handleExport={this.exportExcel.bind(this)}
                  hidePagination
                  parent={this}
                  hideButtonExport
                  ThongKeBaoCao={true}
                  LapBaoCao={true}
                  numberColumnHeader={12}
                  dataSum={this.state.dataSum}
                  tableLoading={this.state.tableLoading}
                  onChangeHeader={this.onChangeHeader.bind(this)}
                >
                  <RowItemTongHopKeKhai importData={this.importData.bind(this)} onChange={this.onItemChange.bind(this)} lapBaoCaoTongHop={true}/>
                </DataTable>
              </ShowIf>
            </div>
            <div className='row pl15 pr15 pb15'>
              <span className='big-border'></span>
            </div>
            <ShowIf condition={this.state.showFile}>
              <div className='row pl30 pr30 '>
                <ContainerFileDinhKem label="3. Danh sách văn bản xử lý" labelClass="title-14" disableTopLine={true} bindValidator={this} data={this.state.listTaiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} allowExcelFile={true}/>
              </div>
            </ShowIf>
          </div>
          <div className="pt30">
            <div className="box-bottom">
              <Button type="button" className="btn-action btn-close" onClick={ this.handleBack.bind(this, false) }><span>Đóng</span></Button>
              <Button type="button" className={`btn-action btn-save btn-green ${this.state.posting ? 'btn-loading-inline' : ''}`}onClick={this.guiBaoCao.bind(this, 'save')}>Lưu</Button>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

LapBaoCaoTongHop.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

export default LapBaoCaoTongHop;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/LapBaoCaoTongHop.jsx